module.exports = __webpack_public_path__ + "img/account-card.3fede332.svg";